export default "__VITE_ASSET__D6nGfypG__"